import { FC } from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { useAppContext } from '@/context/App.context';

export const LocalizedNavLink: FC<NavLinkProps> = (props) => {
  const { language } = useAppContext();
  return (
    <NavLink {...props} to={`/${language}${props.to}`}>
      {props.children}
    </NavLink>
  );
};
